"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const General_1 = require("../types/General");
const appStateSelectAppId_1 = __importDefault(require("./appStateSelectAppId"));
const firebaseRealtimeDbGetRootPath_1 = __importDefault(require("./firebaseRealtimeDbGetRootPath"));
const appStateSelectProjectId_1 = __importDefault(require("./appStateSelectProjectId"));
const firebaseIsPathValid_1 = __importDefault(require("./firebaseIsPathValid"));
const firebaseRealtimeDbDeleteCallableGetParsed = (params) => {
    const onCatch = (error) => {
        params.executeProcesses(params.functionId, params.callbacks[General_1.DEFINITION_PROP_NAMES.CATCH], error);
    };
    const path = params.entryVars[General_1.DEFINITION_PROP_NAMES.PATH];
    if (!(0, ts_validators_1.valueIsString)(path) || path === '') {
        onCatch('Validation: Path is not a non empty string');
        return undefined;
    }
    const validPathMessageError = (0, firebaseIsPathValid_1.default)(path);
    if (validPathMessageError) {
        onCatch(validPathMessageError);
        return undefined;
    }
    const onThen = () => {
        params.executeProcesses(params.functionId, params.callbacks[General_1.DEFINITION_PROP_NAMES.THEN]);
    };
    return {
        appId: (0, appStateSelectAppId_1.default)(params.store.getState()),
        path: `${(0, firebaseRealtimeDbGetRootPath_1.default)({
            isDevelopment: params.processor.root.isInDevelopment,
            projectId: (0, appStateSelectProjectId_1.default)(params.store.getState()),
        })}/${path}`,
        onCatch,
        onThen,
    };
};
exports.default = firebaseRealtimeDbDeleteCallableGetParsed;
